import moment from 'moment';

export default {
  spaceEndDate: (state) => {
    const timeStr = moment(state.space.availiblity_end, 'HH:mm:ss');
    const spaceAvailabilityEnd = moment(state.selectedDate);

    spaceAvailabilityEnd.set({
      hour: timeStr.get('hour'),
      minute: timeStr.get('minute'),
      second: timeStr.get('second'),
    });

    return spaceAvailabilityEnd;
  },

  spaceStartDate: (state) => {
    const timeStr = moment(state.space.availiblity_start, 'HH:mm:ss');

    return moment(state.selectedDate).set({
      hour: timeStr.get('hour'),
      minute: timeStr.get('minute'),
      second: timeStr.get('second'),
    });
  },

  canAddForSelectedDate: state => (state.selectedDate.diff(moment(), 'days') >= 0),

  isSelectedDateToday: state => state.selectedDate.format('MMMM-DD-YYYY') === moment().format('MMMM-DD-YYYY'),
};



// WEBPACK FOOTER //
// ./src/store/getters.js